/*
 * @author : Kete Martins Rufino
 * @email  : kete@sagaranatech.com
 */
import progressNumbersHelper from 'react/api/dto/ProgressNumbers';

Greenmile.Components = Greenmile.Components || {};

Greenmile.Components.RouteProgressBar = (function () {

    function RouteProgressBar () {

        this.createIconByRouteStatus = function (routeView) {

            var fragment = document.createDocumentFragment(),
                iconClass = routeView.route.status;

            if (routeView.totalStopsInProgress) {
                iconClass = 'STOPS_IN_PROGRESS';
            }

            var routeStatusIcon = document.createElement('div');
            routeStatusIcon.className = 'routeMonitorRouteStatusIcon ' + iconClass;

            fragment.appendChild(routeStatusIcon);

            var eventNotificationIsEnabled = Monet.Security.checkKeyIsEnabled(['TRACKER_EVENT_NOTIFICATION']);
            if (routeView.totalOpenEventLogs && eventNotificationIsEnabled) {
                var routeAlertBadge = document.createElement('div');
                routeAlertBadge.className = 'routeAlertBadge';
                routeAlertBadge.setAttribute('alerts', routeView.totalOpenEventLogs);
                fragment.appendChild(routeAlertBadge);
            }

            return fragment;

        };

        this.createProgressBar = function (route) {

            const fragment = document.createDocumentFragment();

            const routeNumbers = progressNumbersHelper(route);

            const progressBarContainer = document.createElement('div');
            const progressInText = document.createElement('div');

            const progressCanceled = document.createElement('div');
            const progressRedelivered = document.createElement('div');
            const progressUndelivered = document.createElement('div');
            const progressDelivered = document.createElement('div');
            const progressPartial = document.createElement('div');

            progressInText.className = 'progressInText';

            progressInText.innerHTML = routeNumbers.progressText;

            progressCanceled.style.width = routeNumbers.progressCanceled;
            progressRedelivered.style.width = routeNumbers.progressRedelivered;
            progressUndelivered.style.width = routeNumbers.progressUndelivered;
            progressDelivered.style.width = routeNumbers.progressDelivered;
            progressPartial.style.width = routeNumbers.progressPartial;

            progressBarContainer.appendChild(progressDelivered);
            progressBarContainer.appendChild(progressPartial);
            progressBarContainer.appendChild(progressUndelivered);
            progressBarContainer.appendChild(progressRedelivered);
            progressBarContainer.appendChild(progressCanceled);

            progressBarContainer.appendChild(progressInText);

            progressBarContainer.className = 'routeMonitorProgressBarContainer';

            progressCanceled.className = 'progressCanceled';
            progressRedelivered.className = 'progressRedelivered';
            progressUndelivered.className = 'progressUndelivered';
            progressDelivered.className = 'progressDelivered';
            progressPartial.className = 'progressPartial';

            fragment.appendChild(progressBarContainer);
            fragment.appendChild(progressInText);

            return fragment;

        };

    }

    return RouteProgressBar;

}());
